import { render, staticRenderFns } from "./Parteners.vue?vue&type=template&id=0788ab8c&scoped=true&"
import script from "./Parteners.vue?vue&type=script&lang=js&"
export * from "./Parteners.vue?vue&type=script&lang=js&"
import style0 from "./Parteners.vue?vue&type=style&index=0&id=0788ab8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788ab8c",
  null
  
)

export default component.exports